import React from 'react';
import Modal from 'react-modal';

import { useAppSelector } from '../../../hooks/react-redux';
import { PageLoadingDots } from '../../shared/loading-dots/PageLoadingDots';
import { getIsResettingPassword } from '../resetPassword/store';
import styles from './Login.module.scss';
import { getIsSwitchingAccounts } from './store';

export const SwitchAccountOverlay: React.FC = () => {
    const isSwitchingAccount = useAppSelector(getIsSwitchingAccounts);
    const resettingPassword = useAppSelector(getIsResettingPassword);

    return (
        <Modal
            ariaHideApp={false}
            isOpen={isSwitchingAccount && !resettingPassword}
            className={styles.logoutOverlay}
            style={{ overlay: { display: 'flex', zIndex: 20 } }}
            shouldCloseOnEsc={false}
        >
            <PageLoadingDots label='Switching Account...' />;
        </Modal>
    );
};
